import { useState, useCallback, useEffect } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import i18n from "../submodule/src/i18n/i18n";

const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "pt", label: "Português", short: "PT" },
];

const SUPPORTED = LANGUAGES.map((l) => l.code);

const LanguageSelector = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    if (urlLang && SUPPORTED.includes(urlLang)) return urlLang;
    const stored = localStorage.getItem("i18nextLng");
    if (stored && SUPPORTED.includes(stored)) return stored;
    return i18n.language || "en";
  });

  const handleLanguageChange = useCallback((language) => {
    i18n.changeLanguage(language);
    setCurrentLanguage(language);

    localStorage.setItem("i18nextLng", language);

    window.selectedLanguage = language;

    const event = new CustomEvent("languageChanged", { detail: language });
    document.dispatchEvent(event);

    try {
      const submoduleI18n = require("../submodule/src/i18n/i18n").default;
      if (submoduleI18n && submoduleI18n !== i18n) {
        submoduleI18n.changeLanguage(language);
      }
    } catch (error) {
      console.log("Note: Submodule i18n will be handled via props");
    }
  }, []);

  useEffect(() => {
    if (currentLanguage && currentLanguage !== i18n.language) {
      handleLanguageChange(currentLanguage);
    }
  }, [currentLanguage, handleLanguageChange]);

  const currentLang =
    LANGUAGES.find((l) => l.code === currentLanguage) || LANGUAGES[0];

  const handleLanguageClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLanguageSelect = (language) => {
    handleLanguageChange(language);
    handleClose();
  };

  return (
    <div>
      <Button
        onClick={handleLanguageClick}
        variant="text"
        color="inherit"
        className="flex items-center"
        sx={{
          textTransform: "none",
          fontSize: "0.9rem",
          padding: "6px 12px",
          minWidth: "70px",
        }}
        endIcon={<ExpandMoreIcon color="action" sx={{ fontSize: "1.5rem" }} />}
      >
        {currentLang.short}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageSelect(lang.code)}
          >
            <span className="w-7 text-xs font-semibold text-muted-foreground mr-2">
              {lang.short}
            </span>
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LanguageSelector;
